var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 89.53 107.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 89.53,
    height: 107.09
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_1",
    "data-name": "Component 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3750",
    "data-name": "Group 3750"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8502",
    "data-name": "Path 8502",
    className: "cls-3",
    d: "m61.1,10.87c-.65-.41-1.32-.79-2.01-1.15-.55-.29-1.11-.56-1.68-.81-.71-.31-1.43-.6-2.17-.86-6.78-2.38-14.18-2.38-20.96,0-.73.26-1.46.55-2.16.86-.57.25-1.13.52-1.68.81-.69.36-1.36.74-2.01,1.14-7.88,4.71-12.75,13.16-12.89,22.34h58.45c-.13-9.18-5.01-17.63-12.88-22.34m-29.4,12.64c-1.43,0-2.6-1.16-2.6-2.59,0-1.43,1.16-2.6,2.59-2.6,1.43,0,2.6,1.16,2.6,2.59,0,0,0,0,0,0,0,1.43-1.16,2.59-2.59,2.6m26.13,0c-1.43,0-2.6-1.16-2.6-2.59,0-1.43,1.16-2.6,2.59-2.6,1.43,0,2.6,1.16,2.6,2.59h0c0,1.44-1.16,2.6-2.59,2.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8503",
    "data-name": "Path 8503",
    className: "cls-3",
    d: "m63.72,1.38l-4.62,8.34c-.55-.29-1.11-.56-1.68-.81L62.08.48c.12-.21.32-.37.55-.44.09-.02.17-.03.26-.04.16,0,.31.04.45.12.45.25.62.82.37,1.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8504",
    "data-name": "Path 8504",
    className: "cls-3",
    d: "m32.12,8.91c-.57.25-1.13.52-1.68.81L25.81,1.38c-.07-.14-.11-.29-.12-.45,0-.51.41-.93.92-.94,0,0,0,0,.01,0,.09,0,.17.01.25.04.24.07.44.23.56.44l4.68,8.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8505",
    "data-name": "Path 8505",
    className: "cls-3",
    d: "m89.53,40.94v27.29c0,3.62-2.93,6.55-6.55,6.55s-6.55-2.93-6.55-6.55v-27.29c0-3.62,2.93-6.55,6.55-6.55s6.55,2.93,6.55,6.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8506",
    "data-name": "Path 8506",
    className: "cls-3",
    d: "m63.39,84.93v14.45c-.05,4.26-3.55,7.66-7.81,7.61-4.18-.05-7.55-3.43-7.61-7.61v-14.45h15.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8507",
    "data-name": "Path 8507",
    className: "cls-3",
    d: "m13.1,40.94v27.29c0,3.62-2.93,6.55-6.55,6.55s-6.55-2.93-6.55-6.55v-27.29c0-3.62,2.93-6.55,6.55-6.55s6.55,2.93,6.55,6.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8508",
    "data-name": "Path 8508",
    className: "cls-3",
    d: "m41.55,84.93v14.45c-.05,4.26-3.55,7.66-7.8,7.61-4.18-.05-7.55-3.43-7.61-7.61v-14.45h15.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8509",
    "data-name": "Path 8509",
    className: "cls-3",
    d: "m73.41,35.51v42.35c0,3.9-3.16,7.06-7.06,7.06H22.03c-3.9,0-7.06-3.16-7.06-7.06h0l.58-42.35h57.86Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.4824cdc27545e0ed764952b16004cc7e.svg";
export { ForwardRef as ReactComponent };